import { SurveyBuilderState } from '../../shared/types';
import { select } from 'redux-saga/effects';
import { StoreState } from '../../../../index';
import { set } from 'shades';
import { putEffect } from '../../../../../shared/utils/putEffect';
import { changeSectionInfo, setPopup, setQuestion, setSection } from '../actions';
import { SetSkipLogic } from '../types';
import axios from '@utils/axios';
import { surveyQuestionsApiUrl, surveySectionOptionAssetsApiUrl } from './consts';
import { mapShowLogicToDisplayLogicRequest, mapSkipLogicToDisplayLogicRequest } from './utils';
import { getApiError } from '../../../../../shared/utils/getApiError';
import { getApiEndPointUrl } from '../../../../../shared/utils/getApiEndpointUrl';
import { assign } from 'shared/utils/assign';
import { pend, reject, fulfill } from 'store/promise/actions';
import { getQuestionsWithoutFunctions } from '@utils/surveyBuilder';

export function* setSkipLogic(action: SetSkipLogic) {
	const { id, logic, type } = action.payload;
	const { questions }: SurveyBuilderState = yield select((s: StoreState) => s.surveyBuilder);
	const q = getQuestionsWithoutFunctions(questions);
	const question = type !== 'section' && set('logic', 'display', 'skipIf')(logic)(q[id]);
	const isShowSkipLogicApplied = question?.logic?.display?.skipIf?.length !== 0;

	// const nextQueId = Object?.keys(questions)?.find(
	// 	(key) => questions[key]?.orderPosition === question?.orderPosition + 1
	// );
	// //pagebreak true for next question if skip-logic is enabled
	// if (!!nextQueId && isShowSkipLogicApplied) {
	// 	yield putEffect(
	// 		setQuestion(nextQueId, assign({ pageBreak: true }, questions[nextQueId].questions?.[0]?.[nextQueId]), false)
	// 	);
	// }
	if (type === 'section') {
		const section = set('logic', 'display', 'skipIf')(logic)(questions[id]);
		yield putEffect(setSection(id, section, false, false));
		try {
			yield putEffect(pend(changeSectionInfo));
			let updates = {
				id: id,
				display: {
					...mapShowLogicToDisplayLogicRequest(section.logic.display),
					...mapSkipLogicToDisplayLogicRequest(section.logic.display),
				},
			};
			const res = yield axios.patch(getApiEndPointUrl(surveySectionOptionAssetsApiUrl), updates);
			yield putEffect(setPopup(''));
			yield putEffect(fulfill(changeSectionInfo, { payload: { ...updates, res }, res }));
		} catch (e) {
			yield putEffect(reject(changeSectionInfo, getApiError(e)));
			yield putEffect(setPopup(getApiError(e)));
		}
	} else {
		const nextQueId: any = Object?.keys(q)?.find(
			(key) => questions[key]?.orderPosition === question?.orderPosition + 1
		);
		//pagebreak true for next question if display-logic is enabled
		if (!!nextQueId && isShowSkipLogicApplied) {
			yield putEffect(setQuestion(nextQueId, assign({ pageBreak: true }, q[nextQueId]), false));
		}
	}

	try {
		yield axios.patch(getApiEndPointUrl(surveyQuestionsApiUrl, question.id), {
			questionId: question.id,
			questionType: question.type,
			display: {
				...mapShowLogicToDisplayLogicRequest(question.logic.display),
				...mapSkipLogicToDisplayLogicRequest(question.logic.display),
			},
			// display: mapSkipLogicToDisplayLogicRequest(question.logic.display), // USED THIS ONCE BACKEND IS CHANGED
		});

		yield putEffect(
			setQuestion(id, assign({ pageBreak: isShowSkipLogicApplied ? true : question?.pageBreak }, question))
		);
	} catch (e) {
		yield putEffect(setPopup(getApiError(e)));
	}
}
